export default __webpack_public_path__ + "static/media/skoda.56c9a1cf.svg";